import { ChevronDownIcon, ShoppingBagIcon } from '@heroicons/react/outline';
import { useStore } from 'context/store-context';
import { useNavigate } from 'react-router-dom';

export const StoreSwitcher = ({
  canSwitchStore = true,
}: {
  canSwitchStore?: boolean;
}) => {
  const {
    storeId,
    storeName,
    storeDomain,
    userStores,
    isLoading,
    updateUserStore,
  } = useStore();
  const navigate = useNavigate();
  const stores = userStores || [];
  const currentStore = stores.find((store) => store.storeId === storeId);
  const loading = Boolean(isLoading);
  const placeholder =
    !canSwitchStore && storeId
      ? storeName || storeDomain || 'Selected store'
      : loading
      ? 'Loading stores…'
      : stores.length
      ? 'Choose a store'
      : 'No stores connected';
  const disabled =
    !canSwitchStore || loading || !stores.length || !updateUserStore;

  return (
    <div className="relative block min-w-0">
      <ShoppingBagIcon
        className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400"
        aria-hidden="true"
      />
      <select
        aria-label="Switch store"
        value={currentStore?.storeId || ''}
        disabled={disabled}
        title={currentStore?.name || currentStore?.domain || placeholder}
        onChange={(event) => {
          const store = stores.find(
            ({ storeId: id }) => id === event.target.value,
          );
          if (!disabled && store && store.storeId !== storeId) {
            navigate(`/switch-store/${encodeURIComponent(store.storeId)}`);
          }
        }}
        className="w-full min-w-0 appearance-none truncate rounded-lg border border-white/15 bg-[#333333] py-2 pl-9 pr-8 text-sm font-medium text-gray-100 focus:outline-none focus:ring-2 focus:ring-violet-400 disabled:cursor-default disabled:text-gray-400"
      >
        {!currentStore && <option value="">{placeholder}</option>}
        {stores.map((store) => (
          <option key={store.storeId} value={store.storeId}>
            {store.name || store.domain}
          </option>
        ))}
      </select>
      <ChevronDownIcon
        className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400"
        aria-hidden="true"
      />
    </div>
  );
};
